import { Program } from '../models/program';
import { ProgramMetadata } from '../models/program-metadata';

export type LocalizedProgramResponse = {
  program: Program | null;
  programMetadata: ProgramMetadata | null;
};

export type FetchLocalizedProgramBody = {
  key?: string;
  locale?: string;
  preferredLanguage: string;
  programKeys?: string[];
  version?: string | null;
};

// Client-side wrapper around the /api/get-localized-program route. Keeping the
// request shape in one place ensures callers stay in sync with the route's Zod
// schema (src/pages/api/get-localized-program.ts).
export async function fetchLocalizedProgram(body: FetchLocalizedProgramBody): Promise<LocalizedProgramResponse> {
  const response = await fetch('/api/get-localized-program', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch localized program content');
  }

  return (await response.json()) as LocalizedProgramResponse;
}
